export default (element = document.activeElement) =>
  element.tagName === 'INPUT' ||
  element.tagName === 'TEXTAREA' ||
  element.tagName === 'SELECT' ||
  ('isContentEditable' in element && element.isContentEditable);
